import { useLocation } from "react-router-dom";
import CustomTitle from "../../../../components/CustomMiscellaneous/CustomTitle";
import { generalObjectBuilder, genericDelete, genericPost, genericUpdate, paginatedGetWithProcessor } from "../../../../services/api.service";
import TableView from "../../../Common/TableView";
import { SerroteConfig } from "./Serrote.config";


export default function Serrote() {


    const location = useLocation();
    const currentRoute = location.pathname;
    const obraId = currentRoute.split("/")[2];
    const pecaId = currentRoute.split("/")[4];

    const EXTENSION = `/obras/${obraId}/pecas/${pecaId}/operacoes/Serrote`;

    return(<>{EXTENSION?<div>
        <CustomTitle small text={'Operações de Corte'}/>
        <TableView 
        title={"Operações de Corte"}
        postEntity={genericPost(EXTENSION)}
        editEntity={genericUpdate(EXTENSION)}
        deleteEntity={genericDelete(EXTENSION)}
        addButtonText={"Nova Operação"} 
        searchButtonText={"Procurar Operação"}
        tableConfigs={SerroteConfig}
        dataBuildFunction={generalObjectBuilder(SerroteConfig)}
        entityName={"Operações Corte"}
        idProp={"id"}
        configMapKey={`obras/${obraId}/pecas/${pecaId}/operacoes/Serrote`}
        hidePagination
        hideFilters
        reroute={true}
        isSubTable
          />
    </div>:null}</>)

}